<template>
    <div v-if="Object.keys(negotiationSelected).length > 0">
        <div 
            class="panel-tabs"
            :class="[$breakpoint.smAndDown ? 'mt-2' : 'mt-1']"
        >
            <div class="nav-tabs_parent">
                <ul 
                    class="nav nav-tabs"
                    :class="{'ml-2' : $breakpoint.smAndDown}"
                >
                    <li class="nav-item" :class="[{active: activeTabIndex == 0}, 
                        {'first': negotiationSelected.counterOffers && negotiationSelected.counterOffers.length > 0}]">
                        <a class="nav-link" @click="selectTab(-1)"
                            href="#">Overview</a>
                    </li>
                    <li class="nav-item" :class="{active: (activeTabIndex == key + 1)}" ref="conversationTab"
                        v-for="(counter, key) in negotiationSelected.counterOffers" :key="key">
                        <a class="nav-link" :class="{active: (activeTabIndex == key + 1)}" @click="selectTab(key)"
                            href="#">
                            <img v-if="counter.seller && counter.seller.img==='default'" class="profile-image float-left" src="assets/default.jpg" alt="default profile image">
                            <span class="user-details flex-column d-flex align-items-center">
                                <i v-if="counter.seller && counter.seller.online" class="fas fa-circle status"></i>
                                <span v-if="counter.user">{{counter.user.account.name}}</span>
                                <span v-else>N/A</span>
                                <small>
                                    <span v-if="offersTimeRemaining[counter._id] > 0 && !(new Date() > new Date(negotiationSelected.expiry)) && negotiationSelected.status_id == 'ACTIVE'" 
                                        class="counter-offer-countdown">
                                        {{ offersTimeRemaining[counter._id] | countdownshortformat }}
                                    </span>
                                    <span v-else class="counter-offer-countdown negotiation-status">
                                        <span v-if="negotiationSelected.status_id == 'COMPLETED' && 
                                            (negotiationSelected.accepted_counter_offer_id && 
                                            negotiationSelected.counterOffers.find(counter => counter._id == negotiationSelected.accepted_counter_offer_id).user.account.id == counter.user.account.id) ||
                                            (negotiationSelected.accepting_user && negotiationSelected.accepting_user.account.id == counter.user.account.id)" class="static accepted">
                                            Accepted
                                        </span>
                                        <span v-else-if="!offersTimeRemaining[counter._id] && negotiationSelected.status_id == 'ACTIVE' && 
                                            new Date(counter.expires) > new Date()">Loading</span>
                                        <span v-else class="static expired">Expired</span>
                                    </span>
                                </small>
                            </span>
                        </a>
                    </li>
                </ul>
            </div>
            <div class="panel-tab-content">
                <negotiation-overview v-if="activeTabIndex == 0" />
                <div 
                    class="negotiation-panel-content d-flex justify-content-between" 
                    :class="{ 'flex-column' : $breakpoint.smAndDown}"
                    v-else-if="activeTabIndex !== 0">
                    <div 
                        class="negotiation-box"
                        :class="[$breakpoint.smAndDown ? 'w-100' : 'w-50 card border-radius-bottom-right-0']"
                    >
                        <negotiation-actions-panel />
                    </div>
                    <conversation 
                        v-if="!$breakpoint.smAndDown"
                        class="negotiation-box messaging mt-0 " 
                        :class="[$breakpoint.smAndDown ? 'w-100' : 'w-50 border-radius-top-left-0 border-radius-bottom-left-0']"
                    />
                </div>
            </div>
        </div>
        <negotiation-counter-offers v-if="activeTabIndex == 0" />
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import breakpoint from '@/mixins/index';

import NegotiationOverview from '@/components/Negotiations/buyer/NegotiationOverview.vue'
import NegotiationCounterOffers from '@/components/Negotiations/buyer/NegotiationCounterOffers.vue'
import Conversation from '@/components/ChatService/Conversation.vue'
import NegotiationActionsPanel from '@/components/Negotiations/buyer/NegotiationActionsPanel.vue'

export default {
    mixins: [breakpoint],
    components: {
        NegotiationOverview,
        NegotiationCounterOffers,
        Conversation,
        NegotiationActionsPanel
    },
    data(){
        return {
            countdownFunction: ''
        }
    },
    created() {
        this.SELECT_TAB(0)
    },
    computed: {
        ...mapState('negotiation', ['activeTabIndex', 'negotiationSelected', 
            'offersTimeRemaining', 'isStillCalculating', 'startCountdown']),
        ...mapState('login', ['userLoggedIn']),
        ...mapState('notifications', ['notificationList']),
        calculateOfferCountdowns: async function(){
            if (this.negotiationSelected){
                if (this.negotiationSelected.counterOffers){
                    /* Clear any ongoing interval */
                    if (this.countdownFunction){
                        clearInterval(this.countdownFunction)
                    }
                    /* Perform countdowns and checkers only when there is an offer */
                    if (this.negotiationSelected.counterOffers.length > 0){
                        this.countdownFunction = setInterval(() => {
                                if (this.startCountdown == true){
                                    this.UPDATE_OFFER_VALIDITY() // Updates if there is still any available counter offer

                                    // Count down only if there is still a valid counter offer for this negotiation
                                    if (this.isStillCalculating.length < 1 ||
                                        ((this.isStillCalculating.indexOf(true) < this.negotiationSelected.counterOffers.length) &&
                                        this.isStillCalculating.indexOf(true) !== -1)){
                                        this.CALCULATE_OFFER_COUNTDOWNS()
                                    }
                                    else {
                                        clearInterval(this.countdownFunction)
                                    }
                                }
                            }, 1000)
                    }
                }
            }
        },
        
    },
    watch: {
        calculateOfferCountdowns(){},
        openStartNegotiation(){},
        openModal(){}
    },
    methods: {
        ...mapMutations('negotiation', ['SELECT_TAB', 'CALCULATE_OFFER_COUNTDOWNS', 'UPDATE_OFFER_VALIDITY', 'STOP_COUNTDOWN']),
        ...mapActions('conversation',['loadConversation']),
        ...mapActions('negotiation', ['selectNegotiation']),
        ...mapActions('notifications', ['updateNotification']),
        selectTab: function(conversationIndex){
            event.preventDefault()
            // If tab selected is 'Overview', then we can skip loading the messages
            if (conversationIndex > -1){
                const conversationSelectedId = this.negotiationSelected.counterOffers[conversationIndex].conversation_id
                this.loadConversation(conversationSelectedId)

                /* Smooth scroll horizontally to the selected conversation tab */
                let selectedTab = this.$refs.conversationTab[conversationIndex]
                selectedTab.scrollIntoView({block: 'end', behavior: 'smooth'})

                /* Remove red dot notification if needed */
                const negotiationId = this.negotiationSelected._id
                let currentRelevantNotification = this.notificationList.find(notification => notification.type_id === 'NEGOTIATION' && notification.group_id === negotiationId && notification.meta && notification.meta.counterOfferId === this.negotiationSelected.counterOffers[conversationIndex]._id && notification.viewed === null)
                
                if(currentRelevantNotification){
                    this.updateNotification(negotiationId)
                }
            }
            this.SELECT_TAB(conversationIndex + 1)
        },
    },
    beforeDestroy() {
        clearInterval(this.countdownFunction)
        this.STOP_COUNTDOWN()
    }
}
</script>